import { createContext, PropsWithChildren } from "react";
import { useTicketEndpointMutationData } from "@SeemplicityDev/ticket-master";

type FieldsUtilsContextType =
  | ReturnType<typeof useTicketEndpointMutationData>
  | undefined;

export const FieldsUtilsContext =
  createContext<FieldsUtilsContextType>(undefined);

export const FieldsUtilsProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { getPropsFromField, setGetPropsFromField, getMutationArray } =
    useTicketEndpointMutationData();

  return (
    <FieldsUtilsContext.Provider
      value={{ getPropsFromField, setGetPropsFromField, getMutationArray }}
    >
      {children}
    </FieldsUtilsContext.Provider>
  );
};
